import React, { useEffect, useState } from "react";
import StockoutCustomFieldSearchDialogComponent from "./stockoutCustomFieldSearchDialog.component";
import { useDispatch, useSelector } from "react-redux";
import { getLang } from "app/feature/constants";
import {
  getStockoutCustomFieldDropdown,
  resetStockoutCustomFieldDropdown,
} from "modules/stockflow/redux";

function StockoutCustomFieldSearchDialogContainer({
  customFields,
  handleChange,
  disabled,
  handleClear,
}) {
  const dispatch = useDispatch();
  const lang = useSelector((state) => state.constant.languages);
  const userLang = useSelector((state) => state.profile.language);
  const drawerOpen = useSelector((state) => state.app.drawerOpen);

  const customFieldsDropdown = useSelector(
    (state) => state.stockflowStockout.customFieldDropdown.list
  );
  const isError = useSelector(
    (state) => state.stockflowStockout.customFieldDropdown.isError
  );

  const [isOpen, setIsOpen] = useState(false);
  const [extraChip, setExtraChip] = useState({
    count: 0,
    offset: 0,
    allOverflow: false,
    overflowChild: [],
  });
  const [filter, setFilter] = useState({
    search: "",
  });

  useEffect(() => {
    getData();

    return () => {
      dispatch(resetStockoutCustomFieldDropdown());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter, dispatch]);

  const getData = () => {
    let param = {
      search: filter.search,
    };

    dispatch(getStockoutCustomFieldDropdown(param));
  };

  const adjustField = (ref) => {
    let children = ref.current?.children[0]?.children;
    let p = ref.current?.children[0];
    if (!children) return;

    if (children.length > 0) {
      // Need to exclude placeholder
      if (children[0].role == null) return;

      children = [...children];

      // max width is 90%. Use 0.9 to calc field width
      let panelWidth = ref.current?.getBoundingClientRect().width * 0.9;
      let childWidth = 0;

      // Check for no overflow child count
      let inRangeCount = children.filter((child, index) => {
        let panelContentWidth = p.getBoundingClientRect().width;
        // get exact width + padding with decimal
        childWidth +=
          parseInt(window.getComputedStyle(child).marginRight) +
          child.getBoundingClientRect().width;

        // Check if overflow
        if (panelWidth - panelContentWidth < 1) {
          // need to add 0.5 as the ellipsis padding (0.5 = ellipsis padding)
          // if the overflow happen before last child, need inlude another 10 for the ellipsis (10 = ellipsis width)
          return index !== children.length - 1
            ? childWidth + 10.5 < panelContentWidth
            : childWidth + 0.5 < panelContentWidth;
        }

        return panelWidth > panelContentWidth;
      }).length;

      if (inRangeCount > 0) {
        let lastRangeChild = children[inRangeCount - 1];

        let outRangeChild = customFields.slice(inRangeCount);

        // Check for overflow child count
        let extraCount = customFields.length - inRangeCount;
        setExtraChip({
          count: extraCount,
          offset: lastRangeChild.offsetLeft + lastRangeChild.offsetWidth,
          allOverflow: false,
          overflowChild: outRangeChild,
        });
      } else {
        setExtraChip({
          count: customFields.length,
          offset: 0,
          allOverflow: true,
          overflowChild: customFields,
        });
      }
    } else {
      setExtraChip({
        count: 0,
        offset: 0,
        allOverflow: false,
        overflowChild: [],
      });
    }
  };

  const handleSearch = (values) => {
    let temp = values.customFields.reduce((list, a) => {
      if (a.info && a.search) {
        list.push(a);
      }
      return list;
    }, []);
    handleChange(temp);
    setIsOpen(false);
  };

  return (
    <StockoutCustomFieldSearchDialogComponent
      customFields={customFields}
      disabled={disabled}
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      lang={lang}
      userLang={userLang}
      placeholder={getLang(lang, "placeholder.SEARCH_BY_CUSTOM_FIELDS")}
      extraChip={extraChip}
      adjustField={adjustField}
      handleSearch={handleSearch}
      drawerOpen={drawerOpen}
      setFilter={setFilter}
      customFieldsDropdown={customFieldsDropdown}
      isError={isError}
      filter={filter}
      handleClear={handleClear}
    />
  );
}

export default StockoutCustomFieldSearchDialogContainer;
